import { eDiscountType } from './eDiscountType';
import {
  convertFromReissueDiscountDataToReissueDiscountResponse,
  convertFromReissueDiscountResponseToReissueDiscountData,
  IReissueDiscountData,
  IReissueDiscountRequest,
  IReissueDiscountResponse,
} from './IReissueDiscount';

export type TDiscountsTypeResponse = IReissueDiscountResponse;
export type TDiscountsTypeRequest = IReissueDiscountRequest;
export type TDiscountsTypeData = IReissueDiscountData;

export interface IDiscountsRequest {
  amountCents?: number;
  applied?: boolean;
  priorPolicyDetails?: TDiscountsTypeRequest;
}

export interface IDiscountsResponse {
  id: string;
  discountType: eDiscountType;
  cdItemV3Id: string;
  amountCents?: number;
  applied?: boolean;
  priorPolicyDetails?: TDiscountsTypeResponse;
}

export interface IDiscountsData {
  id: string;
  discountType: eDiscountType;
  cdItemsId: string;
  amountCents?: number;
  applied?: boolean;
  priorPolicyDetails?: TDiscountsTypeData;
}

export const convertFromDiscountsDataToDiscountsRequest = (data: IDiscountsData): IDiscountsRequest => ({
  amountCents: data.amountCents,
  applied: data.applied,
  priorPolicyDetails:
    data.priorPolicyDetails && convertFromReissueDiscountDataToReissueDiscountResponse(data.priorPolicyDetails),
});

export const convertFromDiscountsDataToDiscountsResponse = (data: IDiscountsData): IDiscountsResponse => ({
  id: data.id,
  discountType: data.discountType,
  cdItemV3Id: data.cdItemsId,
  amountCents: data.amountCents,
  applied: data.applied,
  priorPolicyDetails:
    data.priorPolicyDetails && convertFromReissueDiscountDataToReissueDiscountResponse(data.priorPolicyDetails),
});

export const convertFromDiscountsResponseToDiscountsData = (data: IDiscountsResponse): IDiscountsData => ({
  id: data.id,
  discountType: data.discountType,
  cdItemsId: data.cdItemV3Id,
  amountCents: data.amountCents,
  applied: data.applied,
  priorPolicyDetails:
    data.priorPolicyDetails && convertFromReissueDiscountResponseToReissueDiscountData(data.priorPolicyDetails),
});

export const convertFromDiscountsDataArrayToDiscountsResponseArray = (data: IDiscountsData[]): IDiscountsResponse[] =>
  data.map((d) => convertFromDiscountsDataToDiscountsResponse(d));

export const convertFromDiscountsResponseArrayToDiscountsDataArray = (data: IDiscountsResponse[]): IDiscountsData[] =>
  data.map((d) => convertFromDiscountsResponseToDiscountsData(d));

export const convertFromDiscountsDataArrayToDiscountsRequestArray = (data: IDiscountsData[]): IDiscountsRequest[] =>
  data.map((d) => convertFromDiscountsDataToDiscountsRequest(d));
